import React, { useEffect, useRef, useState } from 'react';

const MultiSelectCheckbox = ({ selectedDevices, setSelectedDevices, setDeviceTouchToggle, optionData }) => {
  
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setDeviceTouchToggle(true);
  };

  // Handles the checkbox change to toggle the selection
  const handleCheckboxChange = (deviceValue) => {
    setSelectedDevices((prevSelected) =>
      prevSelected.includes(deviceValue)
        ? prevSelected.filter((d) => d !== deviceValue) // Deselect
        : [...prevSelected, deviceValue] // Select
    );
  };

  // Render the selected values (device names) in the input field
  const renderSelectedValues = () => {
    // Get the names of the selected devices based on their value (ID)
    const selectedNames = optionData
      ?.filter((device) => selectedDevices?.includes(device?.value || device?._id)) // Filter selected devices by value
      ?.map((device) => device?.label || device?.name); // Get the label (name) of the selected devices

    return selectedNames?.length > 0 ? selectedNames?.join(', ') : 'Select Zone';
  };

  // Handle click outside to close the dropdown
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false); // Close dropdown when clicking outside
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="multi-select-container muiltiselect-filed-wrap" ref={dropdownRef}>
      <div className="multi-select-input" onClick={toggleDropdown}>
        {renderSelectedValues()}
      </div>
      {isOpen && (
        <div className="multi-select-dropdown">
          {optionData?.length > 0 ? (
            optionData?.map((device, index) => (
              <div key={index} className="multi-select-option">
                <input
                  type="checkbox"
                  id={device?.value || device?._id} // Use device.value as the unique ID
                  value={device?.value || device?._id} // Use device.value as the value
                  checked={selectedDevices.includes(device?.value || device?._id)} // Check if the device value is selected
                  onChange={() => handleCheckboxChange(device?.value || device?._id)} // Pass the unique device value
                />
                <label htmlFor={device?.value}>{device?.label || device?.name}</label>
              </div>
            ))
          ) : (
            <div className="no-zones-message"><center>No zones available</center></div> // Display message when no data
          )}
        </div>
      )}
    </div>
  );
};

export default MultiSelectCheckbox;
